import request from "@/utils/request";
import base from './base';
// 定义接口


export const host = base.api_data;

const api_order = '/order/get_order_list/'; // 销售订单列表
const api_order_delete = '/order/get_order_delete/'; // 销售订单单条删除
const api_inventory_adjustment_stats = '/inventory_adjustment/get_inventory_adjustment_stats/'; // 库存损益统计
const api_inventory_adjustment_export = '/inventory_adjustment/export_inventory_adjustment/'; // 库存损益导出
const api_adjustment_details = '/inventory_adjustment/get_adjustment_details/'; // 获取调整单明细
const api_inventory_check_data_print = '/inventory_adjustment/api_inventory_check_data_print/'; // 库存盘点单(制单状态导出)
const api_goods_sale_analysis = '/goods_sale/analysis/'; // 门店单品分析报表
const api_store_category_detail = '/goods_sale/store_category_detail/'; // 门店+商品明细
const api_store_category_summary = '/goods_sale/store_category_summary/'; // 门店+类别汇总
const api_upload_display_image = '/goods_sale/upload_display_image/'; // 上传陈列图片
const api_get_display_image = '/goods_sale/get_display_image/'; // 获取陈列图片
const api_delete_display_image = '/goods_sale/delete_display_image/'; // 删除陈列图片

const api_target_tracker_overview = '/target_tracker/daily_overview/'; // 门店销售目标汇总
const api_target_tracker_upsert = '/target_tracker/save_records/'; // 门店目标保存
const api_target_tracker_sync_baseline = '/target_tracker/sync_baseline/'; // 同步基础数据
const api_target_tracker_import = '/target_tracker/import_records/'; // 批量导入门店目标数据
const api_target_tracker_template = '/target_tracker/download_template/'; // 下载导入模板
const api_target_tracker_export = '/target_tracker/export_records/'; // 导出门店目标跟踪明细
//上传图片
// export const uploadUrl='/api//upload';
export default {
  //销售订单
  api_order(params) {
    return request.get(`${host}${api_order}`, { params });
  },
  //销售订单删除   前端给后端回传id
  api_order_delete(params) {
    return request.get(`${host}${api_order_delete}`, { params });
  },
  //库存损益统计
  api_inventory_adjustment_stats(params) {
    return request.get(`${host}${api_inventory_adjustment_stats}`, { params });
  },
  //库存损益导出
  api_inventory_adjustment_export(params) {
    return request.get(`${host}${api_inventory_adjustment_export}`, {
      params,
      responseType: 'blob'
    });
  },
  //获取调整单明细
  api_get_adjustment_details(params) {
    return request.get(`${host}${api_adjustment_details}`, { params });
  },
  //库存盘点单(制单状态导出)
  api_inventory_check_data_print(params) {
    return request.get(`${host}${api_inventory_check_data_print}`, { 
      params,
      responseType: 'blob' // 重要：设置响应类型为blob以处理二进制文件
    });
  },
  // 门店单品分析报表
  api_goods_sale_analysis(params) {
    return request.get(`${host}${api_goods_sale_analysis}`, { params });
  },
  // 门店+商品明细
  api_store_category_detail(params) {
    return request.get(`${host}${api_store_category_detail}`, { params });
  },
 
  // 门店+类别汇总
  api_store_category_summary(params) {
    return request.get(`${host}${api_store_category_summary}`, { params });
  },
  api_upload_display_image(data) {
    return request.post(`${host}${api_upload_display_image}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  // 获取陈列图片
  api_get_display_image(params) {
    return request.get(`${host}${api_get_display_image}`, { params });
  },
  api_get_display_images(params) {
    return request.get(`${host}/goods_sale/get_display_images/`, { params });
  },
  // 删除陈列图片
  api_delete_display_image(data) {
    return request.post(`${host}${api_delete_display_image}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  // 门店销售目标列表
  api_target_tracker_overview(params) {
    return request.get(`${host}${api_target_tracker_overview}`, { params });
  },
  // 保存门店目标数据
  api_target_tracker_upsert(data) {
    return request.post(`${host}${api_target_tracker_upsert}`, data);
  },
  // 同步基础销售/库存数据
  api_target_tracker_sync_baseline(params) {
    return request.post(`${host}${api_target_tracker_sync_baseline}`, params);
  },
  // 获取批量导入URL（用于文件上传）
  api_target_tracker_import_url() {
    return `${host}${api_target_tracker_import}`;
  },
  // 获取模板下载URL
  api_target_tracker_template_url() {
    return `${host}${api_target_tracker_template}`;
  },
  // 导出门店目标跟踪明细
  api_target_tracker_export(params) {
    return request.get(`${host}${api_target_tracker_export}`, {
      params,
      responseType: 'blob' // 重要：设置响应类型为blob以处理二进制文件
    });
  }
};




